import React, { useEffect, useRef, useState } from 'react';

import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

import 'react-calendar/dist/Calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'jalali-moment';
import '../App.css'
import 'persianjs';
import { useLocation } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Grid, Typography, useTheme } from '@mui/material';

const DatePicker = ({ completeDate, setCompleteDate, selectedWeekday, setSelectedWeekday }) => {


    const theme = useTheme();

    const convertToPersianMonth = (month) => {
        const persianMonths = [
            'فروردین', 'اردیبهشت', 'خرداد', 'تیر',
            'مرداد', 'شهریور', 'مهر', 'آبان',
            'آذر', 'دی', 'بهمن', 'اسفند'
        ];
        return persianMonths[month];
    };

    const location = useLocation();
    const currentPage = location.pathname;

    const [appointmentValue, setAppointmentValue] = useState('');
    const [border, setBorder] = useState(false);
    const [currentDate, setCurrentDate] = useState(moment());
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedDay, setSelectedDay] = useState(moment().jDate());
    const [selectedMonth, setSelectedMonth] = useState(moment().jMonth());
    const [selectedMonthName, setSelectedMonthName] = useState(convertToPersianMonth(moment().jMonth()));
    const [selectedYear, setSelectedYear] = useState(moment().jYear());
    const [today, setToday] = useState(moment().jDate());
    const [todayMonth, setTodayMonth] = useState(null)
    const [tehranTime, setTehranTime] = useState('');
    const [show, setShow] = useState(false)
    const [todayPersianDate, setTodayPersianDate] = useState('');
    const [year, setYear] = useState('');
    const [showTimeInterval, setShowTimeInterval] = useState(false)
    const [activeTime, setActiveTime] = useState(1)
    const [friday, setFriday] = useState(false)
    const [condition, setCondition] = useState(false)
    const [currentYaer, setCurrentYear] = useState(null)
    const [persianDateTime, setPersianDateTime] = useState('');


    const gridRef = useRef(null);

    const daysInMonth = currentDate.jDaysInMonth();
    const firstDayOfMonth = moment(currentDate).startOf('jMonth');

    const startTime = moment('2024-01-21T09:00:00');
    const endTime = moment('2024-01-21T21:00:00');
    const [interval, setInterval] = useState(10);

    const minYear = year;

    const handleOutsideClick = (event) => {
        if (gridRef.current && !gridRef.current.contains(event.target)) {
            setBorder(false);
        }
    };

    const handleDayClick = (day) => {
        setSelectedDay(day);
        setCurrentDate((prevDate) => {
            const newDate = moment(prevDate).jDate(day);
            setCompleteDate(newDate.format('jYYYY/jMM/jDD'));
            const weekdays = [
                'شنبه', 'یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه',
                'چهار‌شنبه', 'پنج‌شنبه', 'جمعه'
            ];
            setSelectedWeekday(weekdays[newDate.jDay()]);
            return newDate;
        });
    };


    const convertToPersianNumber = (number) => {
        const persianDigits = [
            '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'
        ];

        return String(number).replace(/\d/g, (digit) => persianDigits[digit]);
    };


    const convertToPersianDate = (date) => {
        return moment(date).format('jYYYY/jM/jD');
    };



    const convertToPersianWeekday = (weekday) => {
        const persianWeekdays = [
            'شنبه', 'یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه',
            'چهار‌شنبه', 'پنج‌شنبه', 'جمعه'
        ];
        return persianWeekdays[weekday];
    };

    const handleMonthChange = (event) => {
        const selectedMonth = parseInt(event.target.value, 10);
        setSelectedMonth(selectedMonth);
        setSelectedMonthName(convertToPersianMonth(selectedMonth));
        setCurrentDate((prevDate) => {
            const newDate = moment(prevDate);
            newDate.jMonth(selectedMonth);
            setCompleteDate(newDate.format('jYYYY/jMM/jDD'));
            const weekdays = [
                'شنبه', 'یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه',
                'چهار‌شنبه', 'پنج‌شنبه', 'جمعه'
            ];
            setSelectedWeekday(weekdays[newDate.jDay()]);
            return newDate;
        });
    };


    const changeMonth = (increment) => {
        setSelectedMonth((prevMonth) => {
            const newMonth = prevMonth + increment;
            setSelectedMonthName(convertToPersianMonth(newMonth));
            setCurrentDate((prevDate) => {
                const newDate = moment(prevDate);
                newDate.jMonth(newMonth);

                // Get a new moment object for today's date
                const today = moment();

                // Calculate the minimum allowed month and year
                const minMonth = today.jYear() === newDate.jYear() ? today.jMonth() : 0;
                const minYear = today.jYear();

                // Allow going back to previous months only if not in the current year and month is greater than or equal to minMonth
                if (increment === -1 && newDate.jYear() === minYear && newDate.jMonth() < minMonth) {
                    return prevDate;
                }

                setCompleteDate(newDate.format('jYYYY/jMM/jDD'));
                setSelectedWeekday(convertToPersianWeekday(newDate.jDay()));
                return newDate;
            });
            return newMonth;
        });
    };

    const changeYear = (increment) => {
        setSelectedYear((prevYear) => {
            const newYear = prevYear + increment;
            setCurrentDate((prevDate) => {
                const newDate = moment(prevDate);
                newDate.jYear(newYear);

                // Get a new moment object for today's date
                const today = moment();

                // Calculate the minimum allowed year
                const minYear = today.jYear();

                // Allow going back to previous years only if year is greater than or equal to minYear
                if (increment === -1 && newDate.jYear() < minYear) {
                    return prevDate;
                }

                // Update the complete date with the new year
                const updatedDate = moment(newDate).format('jYYYY/jMM/jDD');
                setCompleteDate(updatedDate);
                setSelectedWeekday(convertToPersianWeekday(newDate.jDay()));
                return newDate;
            });
            return newYear;
        });
    };


    const handleYearChange = (event) => {
        const selectedYear = parseInt(event.target.value, 10);
        setSelectedYear(selectedYear);
        setCurrentDate((prevDate) => {
            const newDate = moment(prevDate);
            newDate.jYear(selectedYear);
            // Update the complete date with the new year
            const updatedDate = moment(newDate).format('jYYYY/jMM/jDD');
            setCompleteDate(updatedDate);
            setSelectedWeekday(convertToPersianWeekday(newDate.jDay()));
            return newDate;
        });
    };


    const renderCalendar = () => {
        const calendar = {};
        let currentDay = moment(firstDayOfMonth);

        const daysInMonth = currentDate.jDaysInMonth();

        const firstDayOfWeek = currentDay.jDay();

        // Weekdays header
        const weekdaysHeader = (
            <Grid bgcolor={'#eef3ff'} mb={'10px'}>
                <Grid key="weekdays" className="calendar-weekdays" display={'flex'} alignItems={'center'}
                    justifyContent={'space-between'} p={'0px 18px'} bgcolor={'#eef3ff'}>
                    {Array(7).fill(0).map((_, index) => (
                        <Grid key={index} className="weekday" display={'flex'} alignItems={'flex-start'}
                            justifyContent={'center'} lineHeight={'46px'} color={'#6069E7'}>
                            {convertToPersianWeekday(index)}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        );

        for (let i = 0; i < firstDayOfWeek; i++) {
            calendar[i] = [<div key={`placeholder-${i}`} className="calendar-day-column" />];
        }

        // Days of the month
        for (let i = 0; i < daysInMonth; i++) {
            const weekdayIndex = currentDay.jDay();
            calendar[weekdayIndex] = calendar[weekdayIndex] || [];

            const day = currentDay.jDate();
            const isDaySelected = selectedDay === day;

            let isPastDay = false;
            const todayMoment = moment();
            const isCurrentMonth = currentDate.jYear() === todayMoment.jYear() && currentDate.jMonth() === todayMoment.jMonth();

            if (isCurrentMonth) {
                isPastDay = day < todayMoment.jDate();
            } else if (
                currentDate.jYear() < todayMoment.jYear() ||
                (currentDate.jYear() === todayMoment.jYear() && currentDate.jMonth() < todayMoment.jMonth())
            ) {
                isPastDay = true;
            } else {
                isPastDay = false;
            }

            calendar[weekdayIndex].push(
                <Grid key={i} className="calendar-day-column" display={'flex'} alignItems={'flex-end'}
                    style={isPastDay ? { cursor: 'not-allowed', color: '#777' } : { cursor: 'pointer' }}
                    justifyContent={'center'} pb={'10px'} fontSize={'12px'} fontWeight={700}
                    onClick={isPastDay ? null : () => handleDayClick(day)}
                    width={'40px'} height={'40px'}
                    bgcolor={isPastDay || !isDaySelected ? 'transparent' : '#6069E7'}
                    color={isDaySelected ? 'white' : 'black'} borderRadius={'4px'}
                    border={today === i + 1 ? '1px solid #6069E7' : '1px solid transparent'}>
                    {convertToPersianNumber(day)}
                </Grid>
            );

            currentDay.add(1, 'day');
        }

        // Render the calendar
        return (
            <Grid>
                {weekdaysHeader}
                <Grid className="calendar-columns-container" p={'10px 0px'} display={'flex'} alignItems={'flex-start'}
                    justifyContent={'space-between'}>
                    {Object.keys(calendar).map((weekdayIndex) => (
                        <Grid key={weekdayIndex} className="calendar-week">
                            {calendar[weekdayIndex]}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        );
    };


    const dropdownStyles = {
        /* for Firefox */
        MozAppearance: 'none',
        /* for Safari, Chrome, Opera */
        WebkitAppearance: 'none',
        /* for IE10 */
        msExpand: 'none',
    };

    const updateClock = () => {
        const now = moment();
        const tehranNow = now.utcOffset('+0330');
        const hours = tehranNow.hours();
        const amPm = hours >= 12 ? 'بعد از ظهر' : 'قبل از ظهر';
        const formattedTime = tehranNow.format('hh:mm') + ' ' + amPm;

        setTehranTime(convertToPersianNumber(formattedTime));
    };




    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        // Calculate currentDate based on selectedDay
        const updatedDate = currentDate.clone().jDate(selectedDay);

        // Calculate persianDate and persianWeekday based on the updatedDate
        const persianDate = convertToPersianNumber(convertToPersianDate(updatedDate));
        const persianWeekday = convertToPersianWeekday(updatedDate.jDay());

        // Combine persianWeekday and persianDate into a single string
        const persianDateTimeString = `${persianWeekday}، ${persianDate}`;

        // Save persianDateTimeString to state
        setPersianDateTime(persianDateTimeString);
    }, [currentDate, selectedDay]);


    useEffect(() => {

        const selectedDate = currentDate.clone().jDate(selectedDay);
        const selectedWeekday = selectedDate.jDay();
        const generateTimeSlots = () => {
            const slots = [];
            let currentTime = startTime.clone();

            while (currentTime.isBefore(endTime)) {
                const timeSlot = {
                    time: convertToPersianNumber(currentTime.format('HH:mm')), //convert to per
                    isAfternoon: currentTime.isAfter(moment('2024-01-21T12:00:00')),
                    isBeforeNoon: currentTime.isBefore(moment('2024-01-21T12:00:00'))
                };
                if (!(currentTime.isSameOrAfter(moment('2024-01-21T12:00:00')) && currentTime.isSameOrBefore(moment('2024-01-21T13:59:59')))) {
                    if (selectedWeekday !== 6) {
                        setFriday(false)
                        slots.push(timeSlot);
                    } else {
                        setFriday(true)
                    }

                }
                currentTime.add(interval, 'minutes');
            }

            setTimeSlots(slots);
        };

        generateTimeSlots();
    }, [interval]);




    useEffect(() => {
        // Update today's date when the component mounts
        setToday(moment().jDate());

        // Get the month number of today's date
        setTodayMonth(moment().jMonth() + 1)
        updateClock();

    }, []);


    useEffect(() => {
        const todayGregorianDate = moment().locale('en').format('YYYY-MM-DD');
        const todayJalaaliDate = moment(todayGregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
        const year = moment(todayJalaaliDate, 'jYYYY/jMM/jDD').jYear();

        setTodayPersianDate(todayJalaaliDate);
        setYear(year);
    }, []);


    useEffect(() => {
        setCurrentYear(Number(todayPersianDate.split('/')[0]))
    }, [todayPersianDate])



    return (

        <Grid direction={'rtl'}
            width={'100%'}
            borderRadius={'3px'}
            mx={'auto'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            bgcolor={'white'}
            ref={gridRef}>
            <Grid width={'100%'} display={{ xs: 'block', sm: 'flex' }} alignItems={'center'} justifyContent={'center'} gap={'12px'}>
                <Grid className={'calender'} border={'1px solid #c3cad8'} borderRadius={'6px'} width={'100%'} mb={{ xs: '16px', sm: '0px' }}>
                    <Grid display={'flex'} alignItems={'center'} justifyContent={'space-between'} p={'10px 12px'} onClick={() => { setShow(!show) }}>
                        <Grid display={'flex'} alignItems={'center'} gap={'8px'}>
                            <Typography variant='h6' fontFamily={'Vazir'} color={theme.palette.info.dark}>تاریخ :</Typography>
                            <Typography variant={'h5'} fontFamily={'Vazir'}>{convertToPersianNumber(completeDate)}</Typography>
                        </Grid>
                        <CalendarMonthIcon style={{ color: 'darkgray' }} />
                    </Grid>
                    <Grid width={'100%'} height={'1px'} bgcolor={'#ecedf3'}></Grid>
                    <Grid display={{ xs: show ? 'flex' : 'none', sm: 'flex' }} alignItems={'center'} justifyContent={'space-between'}>
                        <Grid
                            width={'50%'}
                            borderLeft={'1px solid #ecedf3'}
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            p={'10px 12px'}
                        >
                            <Typography variant={'h5'} width={'100%'}>
                                <select
                                    disabled={condition}
                                    value={selectedMonth}
                                    onChange={handleMonthChange}
                                    style={{
                                        border: 'none',
                                        outline: 'none',
                                        width: '100%',
                                        fontSize: '16px', ...dropdownStyles
                                    }}
                                >
                                    {Array.from({ length: 12 }, (_, i) => i).map((month) => (
                                        <option key={month} value={month}>
                                            {convertToPersianMonth(month)}
                                        </option>
                                    ))}
                                </select>
                            </Typography>
                            <Grid display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                <KeyboardArrowUpIcon fontSize={'small'} style={{ color: 'darkgray', cursor: "pointer" }}
                                    onClick={() => changeMonth(-1)} />
                                <KeyboardArrowDownIcon fontSize={'small'} style={{ color: 'darkgray', cursor: "pointer" }}
                                    onClick={() => changeMonth(1)} />
                            </Grid>
                        </Grid>
                        <Grid
                            width={'50%'}
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            p={'10px 12px'}
                        >
                            <select
                                disabled={condition}
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    border: 'none',
                                    outline: 'none',
                                    width: '100%',
                                    fontSize: '16px', ...dropdownStyles
                                }}
                            >
                                {Array.from({ length: 20 }, (_, i) => i).map((index) => {
                                    const year = minYear + index;
                                    return (
                                        <option key={index} value={year} style={{ padding: '10px' }}>
                                            {convertToPersianNumber(year)}
                                        </option>
                                    );
                                })}
                            </select>
                            <Grid display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                <KeyboardArrowUpIcon fontSize={'small'} style={{ color: 'darkgray', cursor: 'pointer' }}
                                    onClick={() => changeYear(-1)} />
                                <KeyboardArrowDownIcon fontSize={'small'} style={{ color: 'darkgray', cursor: 'pointer' }}
                                    onClick={() => changeYear(1)} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid width={'100%'} height={'1px'} bgcolor={'#ecedf3'} display={{ xs: show ? 'block' : 'none', sm: 'block' }}></Grid>
                    <Grid id="monthsContainer" display={{ xs: show ? 'block' : 'none', sm: 'block' }}>
                        {
                            renderCalendar()
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    );
};

export default DatePicker;